import type { SurveyStatus } from "@pulse/api/surveyApi";
import { Badge } from "frontend-components";
import { useTranslation } from "react-i18next";

export default function StatusBadge({ status }: { status: SurveyStatus }) {
    const { t } = useTranslation();
    return (
        <Badge
            className="p-1 px-4 text-xs font-normal border-none shadow-none"
            variant={
                status === "ACTIVE"
                    ? "pink-20"
                    : status === "COMPLETED"
                      ? "green-20"
                      : status === "DRAFT"
                        ? "yellow-20"
                        : "dark"
            }
        >
            {t("surveyStatus.status", { context: status.toLowerCase() })}
        </Badge>
    );
}
